
<template>
    <v-row>
        <v-dialog
        v-model="dialog"
        max-width="600"
        >
        <v-card class="card-padding">
            <h2>{{ $vuetify.lang.t('$vuetify.groupWorkdayForm.msgCannotModify')}}</h2>
            <div>
                <div v-for="(listOverlap, key) in groupOverlap" :key = key class="group-of-overlap">
                    <p>{{ $vuetify.lang.t(`$vuetify.groupWorkdayForm.${key}`)}}</p>
                    <ul>
                        <li v-for="overlapDate in listOverlap" :key = overlapDate>
                            {{overlapDate}}
                        </li>
                    </ul>
                </div>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="primary"
                    text
                    x-large
                    @click="submitBtn()"
                >
                    {{ $vuetify.lang.t('$vuetify.groupWorkdayForm.close')}}
                </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    props: {
        groupOverlap: {
            type: Object,
            default: Object
        }
    },
    data () {
        return {
            dialog: false
        }
    },
    methods: {
        submitBtn () {
            this.dialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
.card-padding {
    padding: 20px;
}
.group-of-overlap {
    margin-top: 1rem
}
</style>
